(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teamwear-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('teamwear-form')) {
    class TeamwearForm extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;

        this.form = this.querySelector('form');
        if (!this.form) return;
        this.ready = true;

        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.done = this.querySelector('[data-done]');
        this.nav = this.querySelector('[data-nav]');
        this.prevArrow = this.querySelector('[data-nav] [data-prev]');
        this.nextArrow = this.querySelector('[data-nav] [data-next]');
        this.host = this.closest('dialog-component');
        this.productRoot = this.closest('product-main-alt');
        this.storageKey = 'teamwear-form:' + window.location.pathname;
        this.index = 0;
        this.isDone = false;
        this.sending = false;
        this.variant = null;

        this.addEventListener('click', this);
        this.addEventListener('keydown', this);
        this.addEventListener('input', this);
        this.addEventListener('change', this);
        this.addEventListener('shopify:block:select', this);
        this.form.addEventListener('submit', this);
        if (this.host) {
          this.host.addEventListener('dialog:open', this);
          this.host.addEventListener('dialog:close', this);
        }
        if (this.productRoot) this.productRoot.addEventListener('variant_changed', this);
        window.addEventListener('pageshow', this);

        // Theme editor only: the dialog component locks the page while it is open. When the editor
        // re-renders the section the open dialog is thrown away, so release that lock again.
        if (this.designMode && !document.querySelector('dialog[open]') && document.body.style.position === 'fixed') {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
        }

        const state = this.querySelector('[data-state]');
        const stateName = state ? state.dataset.state : 'idle';

        if (stateName === 'success') {
          // The page was reloaded after Shopify accepted the form: show the thank you message.
          this.clearSaved();
          this.showDone();
          this.cleanUrl();
          this.openDialog();
        } else if (stateName === 'error') {
          // Shopify rejected the form: bring back the answers so nothing has to be typed again.
          this.restoreSaved();
          this.show(0, false);
          this.openDialog();
        } else {
          this.show(0, false);
        }
      }

      disconnectedCallback() {
        if (this.host) {
          this.host.removeEventListener('dialog:open', this);
          this.host.removeEventListener('dialog:close', this);
        }
        if (this.productRoot) this.productRoot.removeEventListener('variant_changed', this);
        window.removeEventListener('pageshow', this);
      }

      get designMode() {
        return Boolean(window.Shopify && window.Shopify.designMode);
      }

      get fields() {
        return Array.from(this.querySelectorAll('[data-field]'));
      }

      handleEvent(event) {
        switch (event.type) {
          case 'click':
            this.onClick(event);
            break;
          case 'keydown':
            this.onKeyDown(event);
            break;
          case 'input':
          case 'change':
            if (event.target.getAttribute('aria-invalid') === 'true') this.validate(this.index);
            break;
          case 'submit':
            // The form is only sent through submit(). Everything else (for example Enter) is stopped here.
            if (!this.sending) event.preventDefault();
            break;
          case 'dialog:open':
            requestAnimationFrame(() => {
              if (this.isDone && this.done) this.done.focus({ preventScroll: true });
              else this.focusCurrent();
            });
            break;
          case 'dialog:close':
            if (this.isDone) this.reset();
            break;
          case 'variant_changed':
            this.variant = event.detail && event.detail.variant ? event.detail.variant : null;
            this.applyVariant();
            break;
          case 'shopify:block:select':
            this.onBlockSelect(event);
            break;
          case 'pageshow':
            if (event.persisted) this.setBusy(false);
            break;
        }
      }

      onClick(event) {
        const control = event.target.closest('[data-next], [data-prev], [data-submit], [data-close]');
        if (!control || !this.contains(control)) return;

        if (control.hasAttribute('data-next')) this.goNext();
        else if (control.hasAttribute('data-prev')) this.show(this.index - 1);
        else if (control.hasAttribute('data-submit')) this.submit();
        else if (control.hasAttribute('data-close')) this.closeDialog();
      }

      onKeyDown(event) {
        if (event.key !== 'Enter' || event.target.tagName !== 'INPUT') return;

        event.preventDefault();
        if (this.index === this.steps.length - 1) this.submit();
        else this.goNext();
      }

      onBlockSelect(event) {
        const index = this.steps.indexOf(event.target.closest('[data-step]'));
        if (index === -1) return;

        this.isDone = false;
        this.show(index, false);
        this.openDialog();
      }

      show(index, focus = true) {
        if (!this.steps.length) return;

        this.index = Math.max(0, Math.min(index, this.steps.length - 1));
        this.steps.forEach((step, position) => {
          step.hidden = position !== this.index;
        });
        if (this.done) this.done.hidden = true;
        if (this.nav) this.nav.hidden = this.steps.length < 2;
        if (this.prevArrow) this.prevArrow.disabled = this.index === 0;
        if (this.nextArrow) this.nextArrow.disabled = this.index === this.steps.length - 1;
        if (focus) this.focusCurrent();
      }

      focusCurrent() {
        const step = this.steps[this.index];
        const field = step ? step.querySelector('[data-field]') : null;
        if (field) field.focus({ preventScroll: true });
      }

      validate(index) {
        const step = this.steps[index];
        const field = step ? step.querySelector('[data-field]') : null;
        if (!field) return true;

        if (field.tagName !== 'SELECT' && field.type !== 'number') field.value = field.value.trim();

        const valid = field.checkValidity();
        const error = step.querySelector('[data-error]');

        if (valid) field.removeAttribute('aria-invalid');
        else field.setAttribute('aria-invalid', 'true');

        if (error) {
          error.textContent = valid ? '' : this.messageFor(field);
          error.hidden = valid;
        }

        return valid;
      }

      messageFor(field) {
        // Own texts instead of the browser's, so the message does not depend on the browser language.
        const validity = field.validity;
        let message = this.dataset.msgInvalid;

        if (validity.valueMissing) message = this.dataset.msgRequired;
        else if (validity.typeMismatch && field.type === 'email') message = this.dataset.msgEmail;

        return message || field.validationMessage;
      }

      goNext() {
        if (!this.validate(this.index)) {
          this.focusCurrent();
          return;
        }

        this.show(this.index + 1);
      }

      submit() {
        if (this.sending) return;

        for (let index = 0; index < this.steps.length; index += 1) {
          if (!this.validate(index)) {
            this.show(index);
            return;
          }
        }

        // In the theme editor nothing is sent, so the thank you message can be previewed.
        if (this.designMode) {
          this.showDone();
          return;
        }

        this.save();
        this.setBusy(true);

        // requestSubmit() fires a real submit event, so Shopify's own spam protection keeps working.
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          const button = document.createElement('button');
          button.type = 'submit';
          button.hidden = true;
          this.form.appendChild(button);
          button.click();
          button.remove();
        }
      }

      setBusy(busy) {
        this.sending = busy;
        const button = this.querySelector('[data-submit]');
        if (!button) return;

        if (busy) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      }

      showDone() {
        this.isDone = true;
        this.steps.forEach((step) => {
          step.hidden = true;
        });
        if (this.nav) this.nav.hidden = true;
        if (this.done) {
          this.done.hidden = false;
          this.done.focus({ preventScroll: true });
        }
      }

      reset() {
        this.isDone = false;
        this.setBusy(false);
        this.form.reset();
        this.fields.forEach((field) => field.removeAttribute('aria-invalid'));
        this.querySelectorAll('[data-error]').forEach((error) => {
          error.textContent = '';
          error.hidden = true;
        });
        this.applyVariant();
        this.show(0, false);
      }

      applyVariant() {
        const variant = this.variant;
        if (!variant) return;

        const title = this.querySelector('[data-variant-title]');
        const sku = this.querySelector('[data-variant-sku]');
        const url = this.querySelector('[data-variant-url]');

        if (title) title.value = variant.public_title || variant.title || '';
        if (sku) sku.value = variant.sku || '';
        if (url) url.value = url.dataset.variantUrl + '?variant=' + variant.id;
      }

      openDialog() {
        if (!this.host) return;

        customElements.whenDefined('dialog-component').then(() => {
          if (typeof this.host.showDialog === 'function') this.host.showDialog();
        });
      }

      closeDialog() {
        if (this.host && typeof this.host.closeDialog === 'function') this.host.closeDialog();
      }

      cleanUrl() {
        // Without this, refreshing the page would show the thank you message again.
        const url = new URL(window.location.href);
        if (!url.searchParams.has('contact_posted')) return;

        url.searchParams.delete('contact_posted');
        url.hash = '';
        window.history.replaceState(window.history.state, '', url.toString());
      }

      save() {
        try {
          const answers = {};
          this.fields.forEach((field) => {
            answers[field.name] = field.value;
          });
          window.sessionStorage.setItem(this.storageKey, JSON.stringify(answers));
        } catch (error) {
          // Storage can be unavailable (private mode). The form still works without it.
        }
      }

      restoreSaved() {
        try {
          const answers = JSON.parse(window.sessionStorage.getItem(this.storageKey) || 'null');
          if (!answers) return;

          this.fields.forEach((field) => {
            if (typeof answers[field.name] === 'string') field.value = answers[field.name];
          });
          window.sessionStorage.removeItem(this.storageKey);
        } catch (error) {
          // Nothing to restore.
        }
      }

      clearSaved() {
        try {
          window.sessionStorage.removeItem(this.storageKey);
        } catch (error) {
          // Nothing to clear.
        }
      }
    }

    customElements.define('teamwear-form', TeamwearForm);
  }
  } catch(e) { console.error(e); }
})();

})();
